import { BaseUpdateReleaseRequest } from '@/actions/release';
import { ChecklistItemUpdatable } from '@/actions/updatable';
import { ChecklistItemStatusType, RunwayModelsResponse } from '@/types';

export interface UpdateChecklistItemStatusRequest extends BaseUpdateReleaseRequest {
    checklistSettingId: string;
    userId: string;
    status?: ChecklistItemStatusType;
}

export interface UpdateChecklistItemCommentRequest extends BaseUpdateReleaseRequest {
    checklistSettingId: string;
    userId: string;
    comment?: string;
}

export type UpdateChecklistItemRequestDataType = UpdateChecklistItemStatusRequest | UpdateChecklistItemCommentRequest;

interface UpdateChecklistItemRequestType {
    requestData: UpdateChecklistItemRequestDataType;
    id?: number | string;
}

export interface TryUpdateChecklistItemAction {
    type: ChecklistItemUpdatable;
    payload: UpdateChecklistItemRequestType;
}

export const tryUpdateChecklistItem: (
    type: ChecklistItemUpdatable,
    requestData: UpdateChecklistItemRequestDataType,
    id?: number | string,
) => TryUpdateChecklistItemAction = (type, requestData, id = null) => {
    return {
        type: type,
        payload: {
            requestData,
            id,
        },
    };
};

export const UPDATE_CHECKLIST_ITEM_TEMPLATES = 'UPDATE_CHECKLIST_ITEM_TEMPLATES';
export const DELETE_CHECKLIST_ITEM_TEMPLATES = 'DELETE_CHECKLIST_ITEM_TEMPLATES';

export interface UpdateChecklistItemTemplatesAction {
    type: typeof UPDATE_CHECKLIST_ITEM_TEMPLATES;
    payload: RunwayModelsResponse['checklistItemTemplates'];
}

export const updateChecklistItemTemplates = (
    payload: RunwayModelsResponse['checklistItemTemplates'],
): UpdateChecklistItemTemplatesAction => {
    return {
        type: UPDATE_CHECKLIST_ITEM_TEMPLATES,
        payload: payload,
    };
};

export interface DeleteChecklistItemTemplatesAction {
    type: typeof DELETE_CHECKLIST_ITEM_TEMPLATES;
    payload: RunwayModelsResponse['deletedChecklistItemTemplateIds'];
}

export const deleteChecklistItemTemplates = (
    ids: RunwayModelsResponse['deletedChecklistItemTemplateIds'],
): DeleteChecklistItemTemplatesAction => {
    return {
        type: DELETE_CHECKLIST_ITEM_TEMPLATES,
        payload: ids,
    };
};
